'use client';

import { useState } from 'react';
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
import { ThemeContextProvider } from '@/context/ThemeContext';
import { useAuthStore } from '@/store/auth';

export default function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
    queryCache: new QueryCache({
      onError: (error: any) => {
        if (error.response?.status === 401) {
          useAuthStore.getState().logout();
          window.location.href = '/login';
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (error: any) => {
        if (error.response?.status === 401) {
          useAuthStore.getState().logout();
          window.location.href = '/login';
        }
      },
    }),
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeContextProvider>
        {children}
      </ThemeContextProvider>
    </QueryClientProvider>
  );
}